import AffordableUnitsCreatedWidget from '@/components/Rover/Widgets/AffordableUnitsCreatedWidget';
import ApprovedProjectsWidget from '@/components/Rover/Widgets/ApprovedProjectsWidget';
import BlightedPropertiesEliminatedWidget from '@/components/Rover/Widgets/BlightedProjectEliminatedWidget';
import HousingUnitsCreatedWidget from '@/components/Rover/Widgets/HousingUnitsCreatedWidget';
import NewJobCreatedByClassification from '@/components/Rover/Widgets/JobsCreatedByClassification';
import NewJobCreatedWidget from '@/components/Rover/Widgets/NewJobsCreatedWidget';
import TotalBuildingsWidget from '@/components/Rover/Widgets/TotalBuildingsWidget';
import TotalProgramFundsRemainingWidget from '@/components/Rover/Widgets/TotalProgramFundsRemainingWidget';
import TotalPropertiesReturnedToUseWidget from '@/components/Rover/Widgets/TotalPropertiesReturnedToUseWidget';
import TotalValueOfAllProjectsWidget from '@/components/Rover/Widgets/TotalValueOfAllProjectsWidget';

export function CHDOApprovedApplications({ data: widgetsData }: { data: Record<string, any> }) {
  return (
    <>
      <section className='my-4 grid md:grid-cols-2 xl:grid-cols-4 gap-4'>
        <TotalBuildingsWidget count={widgetsData?.totalBuildings ?? 0} />
        <ApprovedProjectsWidget count={widgetsData?.totalApprovedProjects ?? 0} />
        <TotalProgramFundsRemainingWidget count={widgetsData?.totalProgramFundsRemaining ?? 0} />
        <TotalValueOfAllProjectsWidget count={widgetsData?.totalValueOfAllProjects ?? 0} />
        <BlightedPropertiesEliminatedWidget count={widgetsData?.blightedPropertiesEliminated ?? 0} />
        <TotalPropertiesReturnedToUseWidget count={widgetsData?.totalPropertiesReturnedToUse ?? 0} />
        <HousingUnitsCreatedWidget count={widgetsData?.totalHousingUnitsCreated ?? 0} />
        <AffordableUnitsCreatedWidget count={widgetsData?.totalAffordableUnitsCreated ?? 0} />
        <NewJobCreatedWidget count={widgetsData?.totalNewJobsCreated ?? 0} />
      </section>
      <section className='grid md:grid-cols-2 xl:grid-cols-2 gap-4'>
        <NewJobCreatedByClassification jobs={widgetsData?.newJobsCreatedByClassification} />
      </section>
    </>
  );
}
